export function getExcelColumnsByIndex(index, colNumber = '') {
  let letterRepeats = parseInt(index / 26)
  let letterNumber = index % 26
  
  let result = ''
  
  if (letterRepeats > 0)
      result += String.fromCharCode(65 + (letterRepeats - 1))
  
  result += String.fromCharCode(65 + letterNumber)
  
  return `${result}${colNumber}`
}